import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
// style
import { createStyles, makeStyles, styled, alpha } from "@material-ui/styles";
// component
import AvatarTooltip from "../avatar/AvatarTooltip";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPopover-paper": {
    minWidth: "200px",
    maxWidth: "300px",
  },
}));

const renderMenuItem = (menuItems) =>
  menuItems.map(
    ({ children, useMenuItem = true, ...rest }, idx) =>
      (useMenuItem === false && children) || (
        <MenuItem key={idx.toString()} {...rest}>
          {children}
        </MenuItem>
      )
  );

//
const AvatarPopup = ({ tooltipProps, avatarProps, menuProps }) => {
  // style
  const classes = useStyles();
  // props
  const { letter } = avatarProps;
  const { header, body, footer, ...restMenuProps } = menuProps;

  // local state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <AvatarTooltip tooltipProps={tooltipProps} avatarProps={avatarProps} />
      </IconButton>
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        {...restMenuProps}
      >
        {header && renderMenuItem(header)}
        {header && body && <Divider />}
        {body && renderMenuItem(body)}
        {body && footer && <Divider />}
        {footer && renderMenuItem(footer)}
      </StyledMenu>
    </Box>
  );
};

AvatarPopup.propTypes = {
  tooltipProps: PropTypes.objectOf(PropTypes.any),
  menuProps: PropTypes.objectOf(PropTypes.any),
  avatarProps: PropTypes.objectOf(PropTypes.any),
};

AvatarPopup.defaultProps = {
  tooltipProps: {},
  menuProps: {},
  avatarProps: {},
};

export default AvatarPopup;
